import * as _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { ImportService } from '@app/core/services/import.service';
import { AnalysisMissingInvoiceNumberActionService } from '../analysis-missing-invoice-number-actions.service';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { AnalysisMissingInvoiceNumberDetailComponent } from '../detail/analysis-missing-invoice-number-detail.component';

@Component({
  selector: 'app-analysis-missing-invoice-number-pdf-viewer',
  templateUrl: './analysis-missing-invoice-number-pdf-viewer.component.html',
  styleUrls: ['./analysis-missing-invoice-number-pdf-viewer.component.scss']
})
export class AnalysisMissingInvoiceNumberPdfViewerComponent extends AnalysisMissingInvoiceNumberActionService implements OnInit, OnDestroy {
  document: Blob;
  isError: boolean = false;

  @ViewChild("pdfViewerMain", { static: true }) pdfViewerMain: PdfJsViewerComponent;

  constructor(public dialog: MatDialog,
    protected importService: ImportService,
    protected authenticationInfoService: AuthenticationInfoService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super(importService, authenticationInfoService, dialog);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  ngOnInit(): void {
    this.route.data
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(data => {
        this.importMissingInvoiceNumberDocument = data.missingInvoiceNumber;
        this.document = data.document;
        this.isError = _.isNil(this.document);
        this.showDocument();
      });
  }

  showDocument = () => {
    this.pdfViewerMain.pdfSrc = this.document;
    this.pdfViewerMain.downloadFileName = this.importMissingInvoiceNumberDocument.PdfFileName;
    this.pdfViewerMain.refresh();
  }

  goBackToList = () => {
    this.router.navigate(['/analysis/missing-invoice-numbers']);
  }

  onZoom = () => {
    const dialogModal = new ModalHelper().getImportMissingInvoiceNumberDocumentDetail(this.importMissingInvoiceNumberDocument);
    const dialogRef = this.dialog.open(AnalysisMissingInvoiceNumberDetailComponent, dialogModal);

    return dialogRef.afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isSuccess: boolean) => {
        if (isSuccess) {
          this.goBackToList();
        }
      });
  }

  markDocumentAsPicked() {
    super.markDocumentAsPicked();
    this.goBackToList();
  }

  markDocumentAsUnPicked() {
    super.markDocumentAsUnPicked();
    this.goBackToList();
  }
}